import React, { useState } from "react";
import "./SignatureTabBar.css";

const SignatureTabBar = ({ tabs, activeTabId, onTabSelect, onTabClose, onAddTab, maxTabs }) => {
  const [pendingCloseId, setPendingCloseId] = useState(null);
  const pendingTab = tabs.find((t) => t.id === pendingCloseId);

  const handleCloseClick = (e, tab) => {
    e.stopPropagation();
    if (tab.hasContent) {
      setPendingCloseId(tab.id);
    } else {
      onTabClose(tab.id);
    }
  };

  // × is hidden only when: tab is empty AND it's the only tab
  const showClose = (tab) => tab.hasContent || tabs.length > 1;

  return (
    <>
      <div className="signature-tab-bar">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`signature-tab${tab.id === activeTabId ? " active" : ""}`}
            onClick={() => onTabSelect(tab.id)}
          >
            <span className="signature-tab-label">{tab.label}</span>
            {showClose(tab) && (
              <button
                className="signature-tab-close"
                onClick={(e) => handleCloseClick(e, tab)}
                title="סגור טאב"
              >
                ×
              </button>
            )}
          </div>
        ))}
        {tabs.length < maxTabs && (
          <button className="signature-tab-add" onClick={onAddTab} title="טאב חדש">
            +
          </button>
        )}
      </div>

      {pendingCloseId && pendingTab && (
        <div className="tab-close-overlay" onClick={() => setPendingCloseId(null)}>
          <div className="tab-close-confirm" onClick={(e) => e.stopPropagation()}>
            <p>
              לסגור את הטאב של <strong>{pendingTab.label}</strong>?
            </p>
            <p className="tab-close-warn">הפריטים שנוספו לסל לא יישמרו.</p>
            <div className="tab-close-actions">
              <button
                onClick={() => {
                  onTabClose(pendingCloseId);
                  setPendingCloseId(null);
                }}
              >
                סגור
              </button>
              <button onClick={() => setPendingCloseId(null)}>ביטול</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignatureTabBar;
